import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@/storybook/components/Alert/Alert';
import Link from '@/storybook/components/Link/Link';
import Text from '@/storybook/components/Text/Text';
import styles from './DEDataPrivacyDisclaimer.module.css';

interface Person {
  displayName: string;
  email: string;
}

const persons: Person[] = [
  { displayName: 'Jan Leipert', email: 'jan.leipert@roche.com' },
  { displayName: 'Martina Eichacker', email: 'martina.eichacker@roche.com' },
  { displayName: 'Christina Berns', email: 'christina.berns@roche.com' },
  { displayName: 'Christiane Günther', email: 'christiane.guenther@roche.com' },
  { displayName: 'Miriam Link', email: 'miriam.link@roche.com' },
  { displayName: 'Yvonne Moeschter', email: 'yvonne.moeschter@roche.com' },
];

const DEDataPrivacyDisclaimer = () => {
  const { t } = useTranslation();

  const personLinks = persons.map((person, index) => (
    <React.Fragment key={person.email}>
      <span className={styles.personContactLink}>
        <Link to={`mailto:${person.email}`} isExternal appearance="secondary" className={styles.link}>
          {person.displayName}
        </Link>
      </span>
      {index < persons.length - 1 && ', '}
    </React.Fragment>
  ));

  return (
    <Alert message={t('header.deDisclaimer.title')} variant="warning">
      <Text as="p" className={styles.para}>
        {t('header.deDisclaimer.paragraph1')}
      </Text>
      <Text as="p" className={styles.para}>
        {t('header.deDisclaimer.paragraph2')}
      </Text>
      <Text as="p" className={styles.para}>
        {t('header.deDisclaimer.paragraph3')}
      </Text>
      <Text as="div" className={styles.para}>
        {t('header.deDisclaimer.paragraph4')}
        {personLinks}
      </Text>
    </Alert>
  );
};

export default DEDataPrivacyDisclaimer;
